const FlightStyles = (theme) => {
    return {
        rooted: {
            display: "flex",
        },
        formControl: {
            //margin: theme.spacing(1),
            width: 200
        },
        root: {
            flexGrow: 1,
            height: 250,
        },
        container: {
            flexGrow: 1,
            position: "relative",
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(1),
            left: 0,
            right: 0,
        },
        chip: {
            margin: theme.spacing(0.5, 0.25),
        },
        inputRoot: {
            flexWrap: "wrap",
        },
        inputInput: {
            width: "auto",
            flexGrow: 1,
        },
        divider: {
            height: theme.spacing(2),
        },
        progress: {
            margin: theme.spacing(2),
        },

        priceTooltip: {
            width: 400,
            minWidth: 400,
            maxWidth: 400,
        },

        gridRoot: {
            flexGrow: 1,
        },
        gridPaper: {

        },
        gridControl: {
            padding: theme.spacing(2),
        },
        formRoot: {
            '& .MuiTextField-root': {
                margin: theme.spacing(1),
                width: '25ch',
            },
            '& .MuiTypography-h6': {
                fontSize: 1.25,
                fontFamily: "Ubuntu,sans-serif",
                fontWeight: 500,
                lineHeight: 1.6,
                letterSpacing: 0.0075,
            },
            '& .MuiTypography-root': {
                margin: 0
            }
        },
        avatar: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },
        dateSelector: {
          marginTop: 0,
          marginBottom: 0,
        },
        scheduledTripLegEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        TripLegEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        FlightList: {
            "& .MuiTableHead-root": {
                display: "block",
                tableLayout: "fixed",
                width: "calc(100% - 20px)"
            },
        },
        FlightListEdit: {
            "& .MuiTableHead-root": {
                display: "block",
                tableLayout: "fixed",
                width: "calc(100% - 20px)"
            },
            "& .MuiTableHead-root tr th:first-of-type": {
                maxWidth: 28,
                overflow: "hidden"
            },
            "& .MuiTableHead-root tr th:first-of-type span.MuiCheckbox-root span.MuiIconButton-label": {
                marginLeft: -4
            },
        },
        PassportEditor: {
            "& .MuiTableHead-root": {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                display: "block",
                tableLayout: "fixed",
                paddingRight: 20,
            },
            "& .MuiTableSortLabel-root": {
                color: theme.palette.secondary.main,
            }
        },
        noteHeader: {
            backgroundColor: "#777777",
            //backgroundColor: "rgba(255,255,255,0.3)",
            fontSize: "13px",
            fontWeight: "bold",
            padding: 1,
            color: "#ffffff"
        },
        eventHeader: {
            backgroundColor: "#777777",
            //backgroundColor: "rgba(255,255,255,0.3)",
            fontSize: "13px",
            fontWeight: "bold",
            padding: 1,
            color: "#ffff00"
        },
        noteBody: {
            lineHeight: 1,
            fontSize:"14px",
            color: "#000000",
            whiteSpace: "normal",
            border: "1px solid #ffffff",
            //backgroundColor: "#dddddd"
            padding: 8
        },
        checklistSectionHeader: {
            backgroundColor: "rgba(0,0,0,0.3)",
            fontSize: 18,
            fontWeight: "bold",
            padding: "8px 3px"
        },
        checklistItem: {
            lineHeight: 1,
            fontSize: 14,
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "#202020",
            padding: "6px 3px"
        },
        delayInfo: {
            lineHeight: 1,
            fontSize:"12px",
            color: "#000000",
            backgroundColor: "#ffff99",
            marginBottom: 4,
            border: "1px solid rgba(0,0,0,0.3)"
        },

        cargoHeader: {
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "rgba(255, 255, 255, 1)",
            fontWeight: "bold",
            marginTop: 8,
            padding: 3
        },
        cargoTableHeader: {
            color: "rgba(255, 255, 255, 1)",
            backgroundColor: "rgba(0,0,0,0.3)",
            fontSize: 10,
        },
        cargoRow: {
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "#202020",
            fontSize: 12,
            borderBottom: "1px solid #d0d0d0",
        },

        cargoClientTableHeader: {
            marginLeft: 30,
            backgroundColor: "rgba(0,0,0,0.3)",
            color: "rgba(255, 255, 255, 1)",
            fontSize: 10,
        },
        cargoClientRow: {
            marginLeft: 30,
            backgroundColor: "rgba(221, 221, 221, 1)",
            color: "#202020",
            fontSize: 10,
            paddingTop: 8,
            paddingBottom: 6,
            borderBottom: "1px solid #d0d0d0",
        },

        weightLine: {
            lineHeight: "20px",
            fontSize: 14,
        },
        WeightLineTotal: {
            lineHeight: "20px",
            fontSize: 14,
            color: "rgba(255, 255, 255, 1)",
            backgroundColor: "rgba(0,0,0,0.4)"
        },
        checklistNote: {
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "#202020",
            // whiteSpace: "pre",
            fontSize: 12,
            lineHeight: 1,
            paddingLeft: 20,
        },
    }
}

export default FlightStyles;
